import React, { useState, useEffect } from "react";
import Select from "react-select";
import { addAssistanceRequest, getAssistanceRequired, getClosestCampus } from "../../services/StudentHubService";
import { useFormik, FormikProvider, Form } from 'formik';
import * as Yup from 'yup';
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import moment from "moment";

function SearchAssistance() {
  const [assistanceData, setAssistanceData] = useState([]);
  const [campusData, setCampusData] = useState([]);
  const brand_id = useSelector((state) => state.brand && state.brand.configuration && state.brand.configuration.id ? state.brand.configuration.id : null);

  const AssistanceRequired = () => {
    getAssistanceRequired().then((res) => {
      if (res.status === 200) {
        setAssistanceData(res.data.resource)
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  const ClosestCampus = () => {
    getClosestCampus({ brand_id }).then((res) => {
      if (res.status === 200) {
        const data = res.data.resource.map((item) => ({ value: item.id, label: item.campus_name }));
        setCampusData(data);
      }
    }).catch((errr) => {
      console.log(errr);
    })
  }

  useEffect(() => {
    AssistanceRequired();
    ClosestCampus();
  }, []);


  const searchAssistanceSchema = Yup.object().shape({
    assistance_required: Yup.string().required("Please select assistance required"),
    closest_campus: Yup.string().required("Please select campus"),
    message: Yup.string().required("Please enter message"),
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      assistance_required: "",
      closest_campus: "",
      closest_campus_label: "",
      message: ""
    },
    validationSchema: searchAssistanceSchema,
    onSubmit: (values, { resetForm }) => {
      const sendData = {
        assistance_required: values.assistance_required,
        closest_campus: values.closest_campus,
        message: values.message,
        date_add: moment(new Date).format("YYYY-MM-DD HH:mm:ss")
        // "2023-03-31 12:13:07"
      }

      addAssistanceRequest(sendData).then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: 'Search Assistance Request Submitted',
          timer: 3000,
          onOpen: function () {
            Swal.showLoading();
          },
        }).then((result) => {
          resetForm();
        })
      }).catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
        });
      })
    }
  });

  const { values, errors, touched, setValues, handleSubmit, handleChange } = formik;


  return (
    <div className="row">
      <div className="col-md-6">
        <div class="card card-profile-info-card mb-4">
          <div class="card-body ">
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div class="form-group-blk mb-3">
                      <label>Assistance Required</label>
                      <div className="input-group-2" title="Assistance Required">
                        <Select
                          className={"form-control custom-select-box " + (touched.assistance_required && errors.assistance_required ? " is-invalid" : "")}
                          name="assistance_required"
                          onChange={(item) => { setValues({ ...values, assistance_required: item.value }) }}
                          value={values.assistance_required}
                          placeholder={values.assistance_required ? values.assistance_required : "Assistance Required"}
                          options={assistanceData}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div class="form-group-blk mb-3">
                      <label>Closest Campus</label>
                      <div className="input-group-2" title="Closest Campus">
                        <Select
                          className={"form-control custom-select-box " + (touched.closest_campus && errors.closest_campus ? " is-invalid" : "")}
                          name="closest_campus"
                          placeholder={values.closest_campus_label ? values.closest_campus_label : "Select Campus"}
                          options={campusData}
                          value={values.closest_campus}
                          onChange={(item) => { setValues({ ...values, closest_campus: item.value, closest_campus_label: item.label }) }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div class="form-group-blk mb-3">
                      <label>Message*</label>
                      <div className="input-group-2">
                        <textarea
                          name="message"
                          title="Message"
                          value={values.message}
                          onChange={handleChange}
                          className={"form-control" + (touched.message && errors.message ? " is-invalid" : "")}
                          placeholder="Enter Message here.."
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 ">
                    {Object.keys(errors).map((key) => (<div className="invalid-feedback d-block">{errors[key]}</div>))}
                  </div>
                  <div className="col-md-12 mt-3 text-center">
                    <button type="submit" class="btn btn-primary" title="Submit Assistance Request"><i class="fal fa-paper-plane"></i> Submit Assistance Request</button>
                  </div>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="header-info-box mb-4">
          <h4>How can we help you?</h4>
          <p>
            Please give as much information as you can to facilitate and help us give you
            the correct information. Remember to include the course/class details related
            to this query.
          </p>
        </div>
      </div>
    </div>
  );
}

export default SearchAssistance;
